import MuiDrawer from '@mui/material/Drawer';
import is from '@sindresorhus/is';
import { useContext } from 'react';

import { ProfileVisibilityForm } from './ProfileVisibilityForm';
import { ProfileVisibilitySimplifiedForm } from './ProfileVisibilitySimplifiedForm';
import { VisibilityFormWrapper } from './VisibilityFormWrapper';
import { ApplicationContext } from '../../../../../../shared/source/context/context';
import {
    useUserProfileVisibilityQuery,
    useUserProfileVisibilityTemplateQuery,
} from '../../../../../../shared/source/query-hooks/profile-visibility';

import type { FunctionComponent } from 'react';

export type VisibilityConfigurationDrawerProps = {
    readonly isOpen: boolean;
    readonly onClose: () => void;
};

export const VisibilityConfigurationDrawer: FunctionComponent<VisibilityConfigurationDrawerProps> = ({
    isOpen,
    onClose,
}) => {
    const { applicationState } = useContext(ApplicationContext);
    const { featureFlagService, myUserProfile } = applicationState;
    const userId = myUserProfile.get('id').unwrapOr('');
    const { data, refetch } = useUserProfileVisibilityQuery(userId);
    const { data: template } = useUserProfileVisibilityTemplateQuery(userId);

    if (is.nullOrUndefined(data) || is.nullOrUndefined(template)) {
        return null;
    }

    const roles = applicationState.customization.get('commonConfiguration').get('visibilityRoles').unwrapOr([]);

    return (
        <MuiDrawer
            anchor="right"
            aria-label="Profile Visibility Drawer"
            open={isOpen}
            PaperProps={{ sx: { width: 'clamp(900px, 66vw, 1080px)' } }}
            onClose={onClose}
        >
            {featureFlagService.isFeatureFlagEnabled('simplified-settings-visibility') ? (
                <VisibilityFormWrapper onClose={onClose}>
                    <ProfileVisibilitySimplifiedForm
                        data={data}
                        refetch={refetch}
                        rolesList={roles}
                        template={template}
                    />
                </VisibilityFormWrapper>
            ) : (
                <ProfileVisibilityForm
                    data={data}
                    refetch={refetch}
                    rolesList={roles}
                    template={template}
                    onClose={onClose}
                />
            )}
        </MuiDrawer>
    );
};
